






























































































































































































































































































































































































































import Vue, { PropType } from "vue";
import DateInput from "../inputs/DateInput.vue";
import { AanvraagGeldigeAncienniteit } from "../../types/NBE/AanvraagGeldigeAncienniteit";
import ToggleInput from "../inputs/ToggleInput.vue";
import TextInput from "../inputs/TextInput.vue";
import { Tewerkstellingsgegevens } from "../../types/NBE/Tewerkstellingsgegevens";
import { AanvraagGASteps } from "../../types/NBE/AanvraagGASteps";
import FileUpload from "../inputs/FileUpload.vue";
import { TewerkstellingsTypes } from "../../types/NBE/TewerkstellingTypes";
import PlusButton from "../interface/PlusButton.vue";
import AanvraagGaOverzicht from "./AanvraagGaOverzicht.vue";
import InfoAlert from "../interface/InfoAlert.vue";
import { dateValidator } from "../utils/DateUtils";
import { minLength, required } from "vuelidate/lib/validators";
import { TewerkstellingsStatus } from "../../types/NBE/TewerkstellingsStatus";
import { AanvraagGAStatus } from "../../types/NBE/AanvraagGAStatus";
import { TewerkstellingsAttest } from "../../types/NBE/TewerkstellingsAttest";
import LoopbaanFiche from "./LoopbaanFiche.vue";
export default Vue.extend({
  name: "ga-form",
  components: {
    DateInput,
    ToggleInput,
    TextInput,
    FileUpload,
    PlusButton,
    AanvraagGaOverzicht,
    InfoAlert,
    LoopbaanFiche,
  },
  props: {
    activeStep: {
      type: Number,
      default: 0,
    },
    aanvraagGa: {
      type: Object as PropType<AanvraagGeldigeAncienniteit>,
    },
  },
  data() {
    return {
      cancelled: false,
    };
  },
  mounted() {
    this.$emit("validation-change", this.$v);
  },
  methods: {
    toggleCancelled() {
      this.cancelled = !this.cancelled;
    },
    updateIsAanvraagGA() {
      this.aanvraagGa.isAanvraagGA = !this.aanvraagGa.isAanvraagGA;
    },
    updateToestemmingAanvraagLoopbaanFiche(value: boolean) {
      this.aanvraagGa.toestemmingAanvraagLoopbaanFiche = value;
    },
    submitForm(): void {
      this.$emit("submit-form", this.aanvraagGa);
    },
    addTewerkstellingOfTypeTo(
      tewArray: Tewerkstellingsgegevens[],
      tewType: TewerkstellingsTypes
    ): void {
      tewArray.push(this.createNewTewerkstelling(tewType));
    },
    createNewTewerkstelling(
      tewerkstellingsType: TewerkstellingsTypes
    ): Tewerkstellingsgegevens {
      return {
        tewerkstellingsType: tewerkstellingsType,
        onbezoldigd: false,
        status: TewerkstellingsStatus.InProgress,
        tewerkstellingsFiles: [] as File[],
      } as Tewerkstellingsgegevens;
    },
    addNewTewerkstellingBinnenOnderwijs(): void {
      this.addTewerkstellingOfTypeTo(
        this.aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs,
        TewerkstellingsTypes.BinnenOnderwijs
      );
    },
    addNewTewerkstellingBuitenOnderwijs(): void {
      this.addTewerkstellingOfTypeTo(
        this.aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs,
        TewerkstellingsTypes.BuitenOnderwijs
      );
    },
    addNewTewerkstellingOpenbaarAmbt(): void {
      this.addTewerkstellingOfTypeTo(
        this.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt,
        TewerkstellingsTypes.OpenbaarAmbt
      );
    },
    addNewOnbezoldigdeOnderbreking(): void {
      this.addTewerkstellingOfTypeTo(
        this.aanvraagGa.onbezoldigdeOnderbrekingen,
        TewerkstellingsTypes.Onbezoldigd
      );
    },
    filesToTewerkstellingen(files: File[]): TewerkstellingsAttest[] {
      var tewAttesten: TewerkstellingsAttest[] = [];
      files.forEach((file) => {
        tewAttesten.push({
          bestandsnaam: file.name,
          pAttachment: 0,
          pRequest: this.aanvraagGa.pRequest,
          contentType: file.type,
        });
      });
      return tewAttesten;
    },
    isTewerkstellingBinnenOnderwijs(tewGegevens: Tewerkstellingsgegevens) {
      return (
        tewGegevens.tewerkstellingsType == TewerkstellingsTypes.BinnenOnderwijs
      );
    },
    isTewerkstellingBuitenOnderwijs(tewGegevens: Tewerkstellingsgegevens) {
      return (
        tewGegevens.tewerkstellingsType == TewerkstellingsTypes.BuitenOnderwijs
      );
    },
    isTewerkstellingOpenbaarAmbt(tewGegevens: Tewerkstellingsgegevens) {
      return (
        tewGegevens.tewerkstellingsType == TewerkstellingsTypes.OpenbaarAmbt
      );
    },
    onFilesChangedBinnenOnderwijs(value: File[], index: number): void {
      this.aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs[
        index
      ].tewerkstellingsFiles = value;

      this.aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs[
        index
      ].tewerkstellingsAttest = this.filesToTewerkstellingen(
        this.aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs[index]
          .tewerkstellingsFiles
      );
    },
    onFilesChangedBuitenOnderwijs(value: File[], index: number): void {
      this.aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs[
        index
      ].tewerkstellingsFiles = value;
      this.aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs[
        index
      ].tewerkstellingsAttest = this.filesToTewerkstellingen(
        this.aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs[index]
          .tewerkstellingsFiles
      );
    },
    onFilesChangedOpenbaarAmbt(value: File[], index: number): void {
      this.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[
        index
      ].tewerkstellingsFiles = value;

      this.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[
        index
      ].tewerkstellingsAttest = this.filesToTewerkstellingen(
        this.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[index]
          .tewerkstellingsFiles
      );
    },
    onSaveNbeRequestProgress(aanvraagGa: AanvraagGeldigeAncienniteit): void {
      this.$emit("on-save-nbe-request-progress", aanvraagGa);
    },
    deleteTewerkstellingBinnenOnderwijs(index: number): void {
      this.aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs.splice(index, 1);
    },
    deleteTewerkstellingBuitenOnderwijs(index: number): void {
      this.aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs.splice(index, 1);
    },
    deleteTewerkstellingOpenbaarAmbt(index: number): void {
      this.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt.splice(index, 1);
    },
    deleteOnbezoldigdeOnderbreking(index: number): void {
      this.aanvraagGa.onbezoldigdeOnderbrekingen.splice(index, 1);
    },
  },
  computed: {
    areFormDetailsShown(): boolean {
      if (this.isTewerkstellingBuitenOnderwijs(this.currentTewGegevens)) {
        return true;
      }
      if (!this.aanvraagGa.toestemmingAanvraagLoopbaanFiche) {
        return true;
      }
      return false;
    },
    aanvraagHasToestemmingDepHO(): boolean {
      return this.aanvraagGa.toestemmingAanvraagLoopbaanFiche;
    },
    aanvraagNeedsInfo(): boolean {
      return this.aanvraagGa.status == AanvraagGAStatus.NeedsInfo;
    },
    aanvraagIsCancelled(): boolean {
      return this.aanvraagGa.status == AanvraagGAStatus.Cancelled;
    },
    currentTewGegevens(): Tewerkstellingsgegevens {
      if (this.activeStep == AanvraagGASteps.TewBinnenOnderwijs) {
        return this.aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs[0];
      } else if (this.activeStep == AanvraagGASteps.TewBinnenOnderwijs) {
        return this.aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs[0];
      } else {
        return this.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[0];
      }
    },
    canContinueStepper(): boolean {
      if (this.activeStep == 0 && !this.aanvraagGa.isAanvraagGA) {
        return false;
      }
      return true;
    },
  },
  validations: {
    aanvraagGa: {
      tewerkstellingsGegevensBinnenOnderwijs: {
        $each: {
          begindatum: {
            dateValidator,
            required,
          },
          einddatum: {
            dateValidator,
            required,
          },
          werkgever: {
            required,
          },
          functie: {
            required,
          },
        },
      },
      tewerkstellingsGegevensBuitenOnderwijs: {
        $each: {
          begindatum: {
            dateValidator,
            required,
          },
          einddatum: {
            dateValidator,
            required,
          },
          functie: {
            required,
          },
          werkgever: {
            required,
          },
          motivering: {
            required,
          },
        },
      },
      tewerkstellingsGegevensOpenbaarAmbt: {
        $each: {
          begindatum: {
            dateValidator,
            required,
          },
          einddatum: {
            dateValidator,
            required,
          },
          functie: {
            required,
          },
          werkgever: {
            required,
          },
          motivering: {
            required,
          },
        },
      },
      onbezoldigdeOnderbrekingen: {
        $each: {
          begindatum: {
            dateValidator,
            required,
          },
          einddatum: {
            dateValidator,
            required,
          },
        },
      },
    },
  },
  watch: {
    canContinueStepper(newValue) {
      this.$emit("can-continue-changed", newValue);
    },
    cancelled(newValue) {
      this.$emit("on-cancelled-change", newValue);
    },
    $v: {
      handler(value) {
        this.$emit("validation-change", value);
      },
      deep: true,
    },
  },
});
